import { useContext } from 'react';
import styled from 'styled-components';
import { PopularReportsContext } from 'contexts/reporting';

interface IReportDetailsProps {
  reportName: string;
  reportType: string;
  items: string[];
}

const Wrapper = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-self: stretch;
  gap: 10px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Title = styled.span`
  color: var(--black-dark, #1a2535);
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`;

const GroupTitle = styled.span`
  color: var(--charcoal, #1e1e1e);
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  width: 85px;
`;
const Row = styled.div`
  max-width: 532px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;

const Details = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 3px;
  flex: 1 0 0;
  flex-wrap: wrap;
`;

const Pill = styled.span`
  display: flex;
  padding: 5px 8px;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
  flex-wrap: wrap;

  border-radius: 30px;
  background: var(--ghost-white, #f2f2f7);

  font-size: 12px;
  font-weight: 400;
  line-height: 14px;

  width: fit-content;
`;

const ReportDetails = ({ reportName, reportType, items }: IReportDetailsProps) => {
  const { buildPopularReportDetails } = useContext(PopularReportsContext);
  const groups = buildPopularReportDetails(reportType, items);
  return (
    <Wrapper>
      <Title>{reportName}</Title>
      <Content>
        {groups.map((group, index) => (
          <>
            <Row key={index}>
              <GroupTitle>{group.title}</GroupTitle>
              <Details>
                {group.items.map((pill, index) => (
                  <Pill key={index}>{pill}</Pill>
                ))}
              </Details>
            </Row>
            {index !== groups.length - 1 && (
              <hr style={{ color: 'var(--ghost-white)', margin: '0', opacity: '1' }} />
            )}
          </>
        ))}
      </Content>
    </Wrapper>
  );
};

export default ReportDetails;
